import { STATICS } from 'statics'
import './style.scss'

export function CarouselNewArrow({
  className,
  onClick,
  icon = <STATICS.ARROW_PREVIOUS />,
  disabled = false,
}) {
  return (
    <button
      type='button'
      onClick={onClick}
      className={`carousel-new-arrow ${className || ''} ${disabled ? '-disabled' : ''}`}
    >
      <div className='icon'>{icon}</div>
    </button>
  )
}
